import React from "react";
import { get } from "../../modules/axios";
import { apiUrl, imgSrc } from "../../modules";
import axios from "axios";
import { Modal } from "antd";

import Slider from "./slider";
import Company from "./company";
import Team from "./team";
import Service from "./service";
import Area from "./area";
import MDDC from "./mddc";
import Contact from "./contact";

class Home extends React.Component {
    state = {
        data: {},
        isModalVisible: true,
    };

    componentDidMount = () => {
        const { history } = this.props;
        const me = this;
        axios
            .get(apiUrl())
            .then(function(response) {
                console.log("res", response);
                console.log(apiUrl());
                if (response.status === 200) {
                    me.setState({ data: response.data });
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        get("", {}, (res) => {
            this.setState({ data: res });
            if (history.location.pathname) {
                window.location = "#" + history.location.pathname.replace("/", "");
            }
        });
    };

    showModal = () => {
        this.setState({ isModalVisible: true });
    };

    handleOk = () => {
        this.setState({ isModalVisible: false });
    };

    handleCancel = () => {
        this.setState({ isModalVisible: false });
    };

    render() {
        const { data, isModalVisible } = this.state;

        return (
            <React.Fragment>
                <main>
                    <Slider slider={data.slider} />
                    <Company />
                    <Service services={data.services} />
                    <Area />
                    <Team teams={data.teams} />
                    <MDDC />
                    <Contact />
                    <div id="menu-sticky">
                        <ul>
                            <li>
                                <a href="https://www.pttor.com/th/oil_price" target="_blank" rel="noreferrer">
                                    <img src={imgSrc("ptt.png", false, "")} alt="ptt" /> <span>ราคาน้ำมัน ปตท.</span>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.moneybuffalo.in.th/rate/oil-price" target="_blank" rel="noreferrer">
                                    <img src={imgSrc("bangchak.png", false, "")} alt="bangchak" /> <span>ราคาน้ำมัน บางจาก</span>
                                </a>
                            </li>
                            <li>
                                <a href="http://bit.phrae.mju.ac.th/carreserve/mapuser.php" target="_blank" rel="noreferrer">
                                    <img src={imgSrc("road.png", false, "")} alt="cal" /> <span>โปรแกรมคำนวณระยะทาง</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <Modal title={null} visible={isModalVisible} width={800} footer={null} onOk={this.handleOk} onCancel={this.handleCancel}>
                        <img src={imgSrc("iso9001.jpg", false, "")} alt="iso9001" />
                    </Modal>
                </main>
            </React.Fragment>
        );
    }
}

export default Home;
